/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var tagInputDefaultProps = {
  autoWidth: false,
  clearable: false,
  dragSort: false,
  excessTagsDisplayType: "break-line",
  defaultInputValue: "",
  minCollapsedNum: 0,
  placeholder: void 0,
  readonly: false,
  size: "medium",
  defaultValue: []
};

export { tagInputDefaultProps };
//# sourceMappingURL=defaultProps.js.map
